import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { REACT_APP_API_URL } from "../../constants/dev";

export default function Search({ onMatch = () => {} }) {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleError = () => {
    setError(true);
    onMatch([]);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setError(false);
    if (value.length >= 2) {
      fetch(`${REACT_APP_API_URL}/rsvp?name=${encodeURIComponent(value)}`)
        .then((response) => response.json())
        .then((data) => {
          if (data.rsvps && data.rsvps.length > 0) {
            onMatch(data.rsvps);
          } else {
            handleError();
          }
        })
        .catch((error) => {
          handleError();
          console.error(error);
        });
    } else {
      handleError();
    }
  };

  return (
    <form
      onSubmit={handleSearch}
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: "1rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            "@media (max-width:600px)": {
              flexDirection: "column",
            },
          }}
        >
          <TextField
            variant="outlined"
            sx={{
              width: "50%",
              marginRight: "2rem",
              "& .MuiOutlinedInput-root": {
                color: "rgb(80, 97, 117)", // text color
                "& fieldset": {
                  borderColor: "rgb(80, 97, 117)", // default border
                },
                "&:hover fieldset": {
                  borderColor: "rgb(64, 80, 97)", // hover border
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgb(64, 80, 97)", // focused border
                },
              },
              "& .MuiInputLabel-root": {
                color: "rgb(80, 97, 117)", // label color
                "&.Mui-focused": {
                  color: "rgb(64, 80, 97)", // focused label color
                },
              },
              "& .MuiFormHelperText-root": {
                color: "rgb(80, 97, 117)", // helper text color
              },
              "@media (max-width:600px)": {
                marginRight: "0",
                marginBottom: "0.5rem",
                width: "90%",
              },
            }}
            value={value}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") e.preventDefault(); // prevent page refresh
            }}
            label="Please enter the name or last name of a guest in your party"
          />
          <Button
            type="submit"
            variant="outlined"
            sx={{
              backgroundColor: "rgb(80, 97, 117)",
              color: "rgb(255, 255, 237)",
              borderColor: "rgb(255, 255, 237)",
              "&:hover": {
                backgroundColor: "rgb(64, 80, 97)", // slightly darker for hover
                borderColor: "rgb(255, 255, 237)",
              },
            }}
          >
            Find RSVP
          </Button>
        </Box>
        {error && (
          <Typography
            sx={{
              textDecoration: "none",
              color: "rgba(221, 44, 0, 0.87)",
              fontFamily: "Pinyon",
            }}
          >
            Hmmm... We're having trouble finding your invite. Please try another
            spelling of your name or contact the couple.
          </Typography>
        )}
      </Box>
    </form>
  );
}
